import type { FsmTranslations } from "@yalana/contracts";
import { WelcomeAdminView } from "./WelcomeAdminView";
import { WelcomeHotelStaffView } from "./WelcomeHotelStaffView";
import { WelcomeManagerView } from "./WelcomeManagerView";

export interface DocumentTypeAction {
  id: string;
  name: string;
  createHref: string;
  viewHref: string;
}

export type DashboardVariant =
  | "hotel-staff"
  | "sports-manager"
  | "mechanic"
  | "admin";

export interface LocationStat {
  id: string;
  name: string;
  city?: string;
  stats: Array<{
    label: string;
    value: number | string;
    highlight?: "warning" | "error";
  }>;
}

export interface WelcomeRequest {
  id: string;
  referenceNo: string;
  documentTypeName: string;
  documentTypeTranslations: FsmTranslations | null;
  currentState: {
    name: string;
    isFinal: boolean;
    translations: FsmTranslations | null;
  };
  updatedAt: string;
  isActionable: boolean;
}

export interface WelcomeDashboardProps {
  userName: string;
  primaryLocation?: string;
  variant: DashboardVariant;
  locations: LocationStat[];
  recentRequests: WelcomeRequest[];
  documentTypes: DocumentTypeAction[];
  /** Base path for request detail links, e.g. `/app/ikos/requests` */
  requestsBasePath: string;
  jwtPayload?: unknown;
  isLoadingLocations?: boolean;
  isLoadingRequests?: boolean;
  /** Present + non-null when the user has `tracking.orderTracking.read` (BEL-777). */
  orderTrackingHref?: string | null;
}

export function WelcomeDashboard(props: WelcomeDashboardProps) {
  const { variant } = props;

  if (variant === "sports-manager") return <WelcomeManagerView {...props} />;
  if (variant === "admin") return <WelcomeAdminView {...props} />;

  // hotel-staff + mechanic — mechanic gets richer view post-MVP
  return <WelcomeHotelStaffView {...props} />;
}
